module.exports = __webpack_public_path__ + "franchise-09.png?0096eb1bbf54ad377910d40bb38216a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/franchise-09.png
// module id = 270
// module chunks = 0